import { ICompanySettingDTO } from 'app/main/pages/settings/company/company-settings.dto';
import { IGetRolesResponse } from 'app/main/pages/users/roles/roles.service';
import { IGroupsPermissionsDto, IUserPermissionDTO } from 'app/store/actions/IUser-data.dto';
import { UserTimezone } from '../main/signing-pages/signing-page/signing-page.dto';


export interface UserSettings {
  id: number
  tenant_owner: boolean
  name: string
  first_name: string,
  last_name: string,
  email: string
  status: string
  phone: string
  signature: string
  login_via: string
  firstname: string
  is_2fa_enabled: boolean
  onboarding: boolean
  application_access: boolean
  remaining_days: number
  token: string
  lastname: string
  permission_addon: PermissionAddon[]
  addon_setting: AddonSetting[]
  user_notification: string
  user_timezone: UserTimezone
  brand: Brand
  workspaces: Workspace[]
  groups: IGroupsPermissionsDto[],
  direct_permissions: IUserPermissionDTO[],
  tenant: Tenant
  roles: IGetRolesResponse[],
  loginAttempt: loginAttempt
  invite_team_token?: string
}

export interface PermissionAddon {
  addon_id: number
  user_id: number
  id: number
  addon_key: string
  addon_title: string
  status: number
}

export interface AddonSetting {
  addon_id: number
  user_id: number
  id: number
  addon_key: string
  status: number
}

export interface Company {
  id: number
  user_id: number
  workspace_id: number
  bcc_active: number
  bcc_pdf_varification: number
  bcc_email: string
  subject: string
  finger_sign: number
  signature_type: number
  remove_pdf: number
  print_doc: number
  outgoing_email: number
  active_footer_email: number
  footer_email: string
  active_invitation: number
  invitation_message: string
  pricing_format_amount: string
  pricing_format_currency: string
  pricing_format_example: string
  system_currency: string
  created_at: string
  updated_at: string
}

export interface Brand {
  id: number
  user_id: number
  workspace_id: number
  logo: string
  title: string
  favicon: string
  sms_originator: string
  heading: string
  font_size: string
  font_style: string
  font_color: string
  created_at: string
  updated_at: string
}

export interface Workspace {
  addon_setting: AddonSettingDTO[]
  id: number
  name: string
  is_organization: boolean
  organization?: string
  registration_number?: string
  phone: string | number
  address?: string
  zipcode?: string
  city?: string
  default: boolean,
  company?: ICompanySettingDTO
}

export interface AddonSettingDTO {
  addon_id: number
  user_id: number
  id: number
  key: string
  active: boolean
}


export interface Tenant {
  organization: string
  registration_number: string
  phone: string
  address: string
  zipcode: string
  city: string
  billing_country: string
  vat_number: string
  trial_ends_at: string
}

export interface Role {
  id: number
  name: string
  predefined: boolean
  default: boolean
  description: string
  permissions: Permission[]
}

export interface Permission {
  id: number
  name: string
}

export interface loginAttempt {
  user_id: number
  ip_address: string
  status: string
  type: string
  login_via: LoginVia
  created_at: string
  operating_system: string
}

export enum LoginVia {
  IFRAMEABLE = 'iframeable',
  SIMPLESIGN = 'simplesign',
  PIPEDRIVE = 'pipedrive',
  SAML = 'saml'
}